import { useCallback, useEffect } from 'react';
import * as React from 'react';

import { FETCHING_STATUSES } from 'constants/globals';
import thematize from 'lib/thematize';
import { useDispatch, useSelector } from 'hooks';
import { NavigateFunction } from 'hooks/useNavigate';
import { createCompany, getCompanyFormData } from 'slices/adminPanel';
import Form from 'components/AdminPanel/Company/CompanyForm';
import Spinner from 'components/Base/Spinner';
import ErrorPage from 'components/ErrorPage';
import styles from './NewCompany.scss';

const theme = thematize(styles);

interface Props {
  navigate: NavigateFunction;
}

const NewCompany = ({ navigate }: Props): React.ReactElement => {
  const dispatch = useDispatch();
  const companyFormData = useSelector(({ adminPanel }) => adminPanel.companyFormData);

  const handleGetData = useCallback(() => {
    if (!companyFormData.data) {
      dispatch(getCompanyFormData());
    }
  }, [dispatch, companyFormData.data]);

  useEffect(() => {
    handleGetData();
  }, [handleGetData]);

  const handleSubmit = (form: API$CompanyFormValues): void => {
    dispatch(
      createCompany({
        data: form,
        onSuccess: (id) => {
          navigate({
            pathname: `/companies/${id}/`,
          });
        },
      })
    );
  };

  const handleCancel = (): void => {
    navigate({
      pathname: '/companies/',
    });
  };

  if (companyFormData.status === FETCHING_STATUSES.SUCCESS) {
    return <Form data={companyFormData.data} onSubmit={handleSubmit} onCancel={handleCancel} />;
  }

  if (companyFormData.status === FETCHING_STATUSES.ERROR) {
    return (
      <ErrorPage showReloadButton containerClassName={theme('error')} onReload={handleGetData} />
    );
  }

  return <Spinner className={theme('spinner')} />;
};

export default NewCompany;
